import { Component, OnInit, Input } from '@angular/core';
import { GridOptions } from "ag-grid/main";
declare var jquery: any;
declare var $: any;
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { ClientsService, RaterDto } from 'app/services/client/ClientsService';

@Component({
  selector: 'app-raters',
  templateUrl: './raters.component.html',
  styleUrls: ['./raters.component.scss']
})
export class RatersComponent implements OnInit {

    raters: any[] = [];
    ratersHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    rowSelection;

    height: number;
    count: number;

    loading: boolean = true;

    rater = {
        "email": "",
        "firstName": "",
        "lastName": "",
        "raterType": 0
    }

    raterTypes: any[] = [];

    @Input('asignmentId') asignmentId: number;

    constructor(
        private _Globals: Globals,
        private _ClientsService: ClientsService,
        private _toastr: ToastrService
    )
    {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
        
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.ratersHeaders = this.createHeaders();

        //service call
        this.getRaters();
        this.getRaterTypes();

        console.log('asignmentId', this.asignmentId);
    }

    saveRater() {
        let rater = new RaterDto();

        //rater.Email = this.rater.email;
        //rater.FirstName = this.rater.firstName;
        //rater.LastName = this.rater.lastName;
        //rater.RaterType = this.rater.raterType;

        console.log("Rater", rater);

        //if (rater.Email == "") {
        //    this._toastr.warning('Empty fields', 'ELI');
        //    return;
        //}

        //if (!this.validateEmail(rater.Email)){
        //    return;
        //}

        this._ClientsService.postSaveRaters(rater).subscribe((data: any) => {
            console.log('response_PostSaveRater', data);
            if (this._Globals.validationToken(data.result.Result)) {

                this.getRaters();
                if (data.result.Result == 1) {
                    this.closeModal();
                    this._toastr.success('Client added successfully', 'ELI');
                } else {
                    this._toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
                }
            } 
        });
    }

    validateEmail(email: string): boolean {
        console.log("email", email);
        $('body').css('cursor', 'wait');

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) return true;
        else {
            this._toastr.warning('Please enter a valid email address', "ELI");
            $('body').css('cursor', 'default');
            return false;
        }
    }

    getSelected() {
        let selected = this.getSelectedRows();
        console.log('selected', selected);
    }

    getSelectedRows(): any {
        return this.gridApi.getSelectedRows();
    }

    getRaters() {
        this._ClientsService.getRaters(88).subscribe((data: any) => {
            console.log('response_GetRaters', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.raters = _data;
                this.loading = false;
            } 
        });
    }

    getRaterTypes() {
        this._ClientsService.getRaterTypes().subscribe((data: any) => {
            console.log('response_GetRaterTypes', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.raterTypes = _data;
                this.rater.raterType = _data[0].Id;
            }
        });
    }

    showModal() {
        this.rater.email = "";
        this.rater.firstName = "";
        this.rater.lastName = "";

        $('#addModal').modal('show');
    }

    closeModal() {
        $('#addModal').modal('hide');
        console.log('hide');
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();
        console.log('header');

        let emailHeader = {
            headerName: 'Email',
            field: 'Email',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emailHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let relationshipHeader = {
            headerName: 'Relationship',
            field: 'Relationship',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(relationshipHeader);

        let addedByHeader = {
            headerName: 'AddedBy',
            field: 'AddedBy',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(addedByHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                switch (params.value) {
                    case 1:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">Active</div>';
                    case 2:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">Pending Activation</div>';
                }
            }
        };
        columnDefs.push(statusHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

}
